module.exports = __webpack_public_path__ + "static/media/estado_cuenta_5.9a8675b0.jpg";